import { ActionCreator, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import api from '../utils/api';
import { BorrowerActionTypes } from '../constants/actionTypes';
import { IBorrowerProfileState } from '../reducers/borrowerProfileReducer';
import BankNames from '../types/BankNames';

export const enum RepaymentTypes {
  MANUAL = 'MANUAL',
  VIRTUAL_ACCOUNT = 'VIRTUAL_ACCOUNT',
}

export interface IBorrowerProfileData {
  totalCredit: number;
  remainingLimit: number;
  name?: string;
  bankNames?: BankNames[];
  blockedReason?: string;
  repaymentType: RepaymentTypes;
}

export type IBorrowerProfileDataAction = {
  type: BorrowerActionTypes.FETCH_BORROWER_PROFILE_DATA;
  borrowerProfileData: IBorrowerProfileData | undefined;
};

export const getBorrowerProfile: ActionCreator<
  ThunkAction<
    Promise<unknown>,
    IBorrowerProfileState,
    null,
    IBorrowerProfileDataAction
  >
> = () => async (dispatch: Dispatch) => {
  try {
    const response = await api.get<IBorrowerProfileData>('/api/v1/profile');
    const action: IBorrowerProfileDataAction = {
      type: BorrowerActionTypes.FETCH_BORROWER_PROFILE_DATA,
      borrowerProfileData: response.data,
    };
    dispatch(action);
  } catch (err) {
    const action: IBorrowerProfileDataAction = {
      type: BorrowerActionTypes.FETCH_BORROWER_PROFILE_DATA,
      borrowerProfileData: undefined,
    };
    dispatch(action);
  }
};
